import styled, { css } from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import * as CashPrice from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";
import * as MonthlyPrice from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";

export const PriceDetailsList = styled.ul<{ isRTL?: boolean }>`
    display: flex;

    ${({ isRTL }) =>
        isRTL
            ? css`
                  flex-flow: column wrap;
              `
            : css`
                  flex-flow: row wrap;
              `};
    padding: 0;

    li {
        display: block;
        list-style-type: none;
        padding: ${theme.space[1]}px 0;
        font-size: 1.3rem;
        line-height: 2rem;
        border-top: 1px solid ${theme.colors.grey2};

        @media ${getBreakpoint("up", "lg")} {
            margin: 0;
            padding: 0;
        }

        &:nth-child(odd) {
            ${({ isRTL }) =>
                isRTL
                    ? css`
                          flex: 0 0 100%;
                          max-width: 100%;
                      `
                    : css`
                          flex: 0 0 50%;
                          max-width: 50%;
                      `};
            padding: ${theme.space[1]}px 0;
            font-family: ${theme.fonts.regular};
            text-align: start;
        }

        &:nth-child(even) {
            ${({ isRTL }) =>
                isRTL
                    ? css`
                          flex: 0 0 100%;
                          max-width: 100%;
                      `
                    : css`
                          flex: 0 0 50%;
                          max-width: 50%;
                      `};
            padding: ${theme.space[1]}px 0;
            font-family: ${theme.fonts.semiBold};
            text-align: end;
            color: ${theme.colors.primaryBlack};
        }

        &:only-child {
            flex: 0 0 100%;
            max-width: 100%;
            font-family: ${theme.fonts.semiBold};
            text-align: end;
            text-transform: uppercase;
            color: ${theme.colors.primaryBlack};
        }

        ${CashPrice.Text} {
            font-family: ${theme.fonts.semiBold};
            font-size: 1.3rem !important;
            text-transform: uppercase;
        }

        ${MonthlyPrice.Text} {
            font-size: 1.3rem;
        }

        &:not(:only-child):last-child {
            width: 100%;

            ${MonthlyPrice.PricesWrapper} {
                align-items: flex-end;

                div {
                    width: 100%;
                }
            }

            ${MonthlyPrice.Text} {
                text-overflow: ellipsis;
                white-space: normal;
                overflow: hidden;
            }
        }
    }

    &:last-of-type {
        li {
            border-bottom: 1px solid ${theme.colors.grey2};
        }
    }

    /* RTL specific layout because of the long price values  */
    ${({ isRTL }) =>
        isRTL &&
        css`
            li {
                flex: 0 0 100% !important;
                text-align: right !important;

                &:nth-child(even) {
                    border-top: 0;
                }
            }
        `};
`;
